import { SvgIcon } from "@mui/material";
import { type BaseIconProps, IconMap } from "./models";

export const BaseIcon = ({ name = "alertCircle", ...props }: BaseIconProps) => {
  const Icon = IconMap[name];
  return (
    <SvgIcon {...props}>
      <Icon />
    </SvgIcon>
  );
};

export type { BaseIconName, BaseIconProps } from "./models";
